export default {"src":"/_next/static/media/embed.17265a92.svg","height":32,"width":32};